import React from 'react';
import { connect } from 'react-redux';

const OrderRowProcessedBy = props => {
  const { order: { processedBy } } = props;
  const processedBy1 = processedBy.split(' ')[0];
  const processedBy2 = processedBy.split(' ')[1];
  return (
    <div>
      <div style={{fontSize: '12px', color: '#555'}}>
        Обработал
      </div>
      <div style={{fontSize: '12px'}}>{processedBy1}</div>
      <div style={{fontSize: '12px'}}>{processedBy2}</div>
    </div>
  );
}

export default connect()(OrderRowProcessedBy);



// WEBPACK FOOTER //
// ./src/components/layout/content/orders/order-row-confirmed/processed-by.js